import { Button } from '@new/common/ui';
import { FC } from 'react';
import { ExamFilterType } from './ExamResultModal';

interface FilterConfig {
  value: ExamFilterType;
  label: string;
}

interface FilterButtonsProps {
  activeFilter: ExamFilterType;
  onFilterChange: (filter: ExamFilterType) => void;
}

const filters: FilterConfig[] = [
  { value: 'all', label: 'All' },
  { value: 'correct', label: 'Correct' },
  { value: 'incorrect', label: 'Incorrect' },
];

export const FilterButtons: FC<FilterButtonsProps> = ({ activeFilter, onFilterChange }) => {
  return (
    <div className="flex gap-2">
      {filters.map((filter) => {
        const isActive = activeFilter === filter.value;
        return (
          <Button
            key={filter.value}
            variant={isActive ? 'primary' : 'neutral'}
            onClick={() => onFilterChange(filter.value)}
            className={`${isActive ? 'bg-(--primary-O900)! text-(--neutral-white-NW1000)! border-(--primary-O900)!' : 'border-(--neutral-white-NW700)! text-(--neutral-white-NW700)!'}`}
          >
            {filter.label}
          </Button>
        );
      })}
    </div>
  );
};
